import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { fetchPropertyManagementByIdAsync } from "./propertyManagementApi";

// async thunk: fetch property management by id
export const fetchPropertyManagementThunk = createAsyncThunk(
  "propertyManagement/fetchById",
  async (propertyManagementId, thunkAPI) => {
    try {
      const response =
        await fetchPropertyManagementByIdAsync(propertyManagementId);

      if (response && response.status === 200 && response.data) {
        return response.data;
      }

      return thunkAPI.rejectWithValue(response);
    } catch (err) {
      return thunkAPI.rejectWithValue(err);
    }
  },
);

const slice = createSlice({
  name: "propertyManagement",
  initialState: { isLoading: true },
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchPropertyManagementThunk.pending, (state) => ({
      ...state,
      isLoading: true,
    }));
    builder.addCase(fetchPropertyManagementThunk.fulfilled, (state, action) => {
      return {
        ...state,
        ...action.payload,
        isLoading: false,
      };
    });
    builder.addCase(fetchPropertyManagementThunk.rejected, (state) => ({
      ...state,
      isLoading: false,
    }));
  },
});

const selectSelf = (state) => state.propertyManagement;
const selectPropertyManagement = (state) => selectSelf(state);

export const propertyManagementSelectors = { selectPropertyManagement };

export const reducer = slice.reducer;
